import {Dialog, Link} from '@wandb/components';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {CodeSnippet} from '../../components/CodeSnippet';
import DOC_URLS from '../../util/doc_urls';
import * as urls from '../../util/urls';

type RunExportModalProps = {
  entityName: string;
  isOpen: boolean;
  onOpenChange(open: boolean): void;
  projectName: string;
  runName: string;
};

export function RunExportModal({
  entityName,
  isOpen,
  onOpenChange,
  projectName,
  runName,
}: RunExportModalProps) {
  const runUrl = urls.run({
    entityName,
    projectName,
    name: runName,
  });

  const createRunCodeSnippet = [
    'import wandb',
    'api = wandb.Api()',
    `run = api.run("${runUrl}")`,
  ].join('\n');

  return (
    <Dialog.Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Heading>Python API</Dialog.Heading>
      <Dialog.Content>
        <TailwindContents>
          <div className="flex flex-col gap-8">
            <h4>Create the run object:</h4>
            <CodeSnippet codeSnippet={createRunCodeSnippet} />
            <h4>Show history data:</h4>
            <CodeSnippet codeSnippet="print(run.history())" />
            <p>
              Check out the{' '}
              <Link href={DOC_URLS.publicApi} target="_blank">
                API docs
              </Link>
              {' for more information.'}
            </p>
          </div>
        </TailwindContents>
      </Dialog.Content>
    </Dialog.Modal>
  );
}
